'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ProgressiveImage from '@/ui/segments/landing/components/progressive-image/progressive-image';
import { Text } from '@/ui/segments/landing/components/text/text';
import { styleButtonHoverable } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import type { ContentForMultipleMemberItem } from '@/services/sanity/api/get-multiple-member';
import styles from './member.module.css';
interface MemberProps {
  className?: string;
  value: ContentForMultipleMemberItem;
}
export default function Member(t0) {
  const $ = _c(25);
  const {
    className,
    value
  } = t0;
  const [maxLines, setMaxLines] = React.useState(2);
  let t1;
  if ($[0] !== maxLines) {
    t1 = () => {
      setMaxLines(maxLines > 0 ? 0 : 2);
    };
    $[0] = maxLines;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleTextOverflow = t1;
  let t2;
  if ($[2] !== className) {
    t2 = classNames(className, styles.member);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== value.imageHeight || $[5] !== value.imageURL || $[6] !== value.imageWidth) {
    t3 = <ProgressiveImage className={styles.picture} src={value.imageURL} width={value.imageWidth} height={value.imageHeight} />;
    $[4] = value.imageHeight;
    $[5] = value.imageURL;
    $[6] = value.imageWidth;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== value.firstName || $[9] !== value.lastName) {
    t4 = <h2>{value.firstName} {value.lastName}</h2>;
    $[8] = value.firstName;
    $[9] = value.lastName;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== maxLines || $[12] !== value.biography) {
    t5 = <Text value={value.biography} maxLines={maxLines} />;
    $[11] = maxLines;
    $[12] = value.biography;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = maxLines > 0 ? "more" : "less";
  let t7;
  if ($[14] !== t6 || $[15] !== toggleTextOverflow) {
    t7 = <button type="button" className={styleButtonHoverable} onClick={toggleTextOverflow}>Read {t6}</button>;
    $[14] = t6;
    $[15] = toggleTextOverflow;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <div className={styles.content}>{t4}{t5}{t7}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t8) {
    t9 = <div className={t2}>{t3}{t8}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}